import React from 'react';
import PropTypes from 'prop-types';

import styles from './ResultsViewSwitch.module.css';

import Tooltip from 'components/common/Tooltip';
import { viewOptions } from 'config/admin/event';

// What each list of a meet's results holds, shown above its button after a
// second's hover (Doug, 2026-10-19). The age view is the "Year View" in a club
// that groups by year level; `words` are the club's (utils/groupLabel.js).
export const viewHelp = (value, words) =>
  value === 'age-view'
    ? `Individual events by ${words.lower.group}: the athletes of one ${words.lower.group} ` +
      'and gender in an event, with all the heats of a round ranked as one list. ' +
      'Relays are not included; see the Event View.'
    : 'Every event as it was run: each heat, semi and final with its own places. ' +
      'Relays are here too, with an Overall tab that places the teams across their races.';

// The Event View / Age View switch of the meet results list, in the filter row.
const ResultsViewSwitch = ({ viewOption, onChange, words }) => (
  <div className={styles.viewToggle}>
    {viewOptions.map((option) => (
      <Tooltip
        key={option.value}
        text={viewHelp(option.value, words)}
        delayMs={1000}
        multiline
      >
        <div
          className={`${styles.viewOption} ${option.value === viewOption ? styles.active : ''}`}
          onClick={() => onChange(option.value)}
        >
          {option.value === 'age-view' ? words.view : option.label}
        </div>
      </Tooltip>
    ))}
  </div>
);

ResultsViewSwitch.propTypes = {
  viewOption: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  // The club's words for its groups (groupWords): "Year View", "year group".
  words: PropTypes.shape({
    view: PropTypes.string.isRequired,
    lower: PropTypes.shape({ group: PropTypes.string.isRequired }).isRequired,
  }).isRequired,
};

export default ResultsViewSwitch;
